module.exports = __webpack_public_path__ + "static/media/icon-20-dollar.0cdef208.svg";